export default [
    {
      path: '/savedquotes',
      name: 'savedquotes',
      component: () => import('@/views/sft/SavedQuotes.vue'),
    },
  ]